// util/useRoleNavigator.js
import { useNavigate } from "react-router-dom";

export function useRoleNavigator() {
  const navigate = useNavigate();

  return function (subroute) {
    const role = localStorage.getItem("role");
    navigate(role && subroute ? `/${role}/${subroute}` : "/unauthorized");
  };
}
